<template>
  <div class="boxLocalOcorrencia">
    <b-modal id="localOcorrencia"
             modal-class="customModal"
             body-class="customModal_body ml-3 mr-3"
             footer-class="customModal_footer"
             centered
             size="xl"
             :hide-header="true"
             :visible="true"
             no-close-on-backdrop
             no-close-on-esc
             @ok="formAddEstab"
             @hide="cleanSelected">
      <div v-if="!hideSearch">
        <div class="row">
          <div class="col-4 form-group">
            <label class="label"
                   :class="{'label_error': error_local_ocorrencia}"
                   for="ocorrenciaNasc">Local de Ocorrência de Nascimento
              <span v-if="error_local_ocorrencia">
                <IconSvg class="icon-error-campo"
                         icon="alert" />
              </span>
            </label>
            <select id="ocorrenciaNasc"
                    v-model="formData.tipo"
                    class="custom-select custom-select-sm"
                    :class="{'is-invalid': error_local_ocorrencia}"
                    name="ocorrenciaNasc"
                    @change="changeLocal(formData.tipo),verifyType(formData.tipo)">
              <option v-for="local in locaisOcorrencia"
                      :key="local.text"
                      :value="local.text">
                {{ local.opt }}
              </option>
            </select>
          </div>

          <div v-if="!showEstab && formData.tipo === 'hospital'"
               class="col-sm-auto col-md-8 form-group">
            <label class="label"
                   :class="{'label_error': error_local_ocorrencia}"
                   for="nomeEstabelecimento">Nome do Estabelecimento
              <span v-if="error_local_ocorrencia">
                <IconSvg class="icon-error-campo"
                         icon="alert" />
              </span>
            </label>
            <input id="nomeEstabelecimento"
                   v-model="localBusca"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': error_local_ocorrencia}"
                   name="nomeEstabelecimento"
                   placeholder="Hospital das Clinicas"
                   type="text"
                   @keyup.enter="searchLocal()">
          </div>
        </div>

        <div v-if="!showEstab && formData.tipo === 'hospital'"
             class="row">
          <div class="col-2 form-group">
            <label class="label"
                   :for="`uf-${_uid}`">UF</label>
            <v-select :id="`uf-${_uid}`"
                      v-model="uf"
                      class="form-control form-control-sm"
                      name="estado"
                      placeholder="Selecione"
                      :options="selectsOptions.states.map((state)=>state.uf)"
                      @input="ufChanged" />
          </div>

          <div class="col-3 form-group">
            <label class="label"
                   :for="`cidade-${_uid}`">Cidade</label>
            <v-select :id="`cidade-${_uid}`"
                      v-model="cidade"
                      name="cidade"
                      class="form-control form-control-sm"
                      placeholder="Selecione"
                      :options="selectsOptions.cities.map((city)=>city.nome)"
                      @input="cityChanged" />
          </div>

          <div v-if="formData.tipo === 'hospital'"
               class="col-12 col-sm-auto align-self-end">
            <div class="form-group">
              <button class="btn btn-block btn-primary btn-sm"
                      type="submit"
                      @click="searchLocal()">
                Pesquisar Estabelecimento
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!showEstab && showHospitais">
        <div v-if="listaHospitais.length">
          <h4 class="titleModal d-inline-block mb-3">
            Escolha um estabelecimento:
          </h4>

          <div v-for="hospital in listaHospitais"
               :key="hospital.hospital_id"
               class="custom-control custom-radio mb-2 ml-2">
            <input :id="hospital.hospital_id"
                   v-model="estabelecimento"
                   class="custom-control-input"
                   name="estabelecimento"
                   type="radio"
                   :value="hospital">
            <label class="custom-control-label text-capitalize"
                   :for="hospital.hospital_id">{{ hospital.nome }} - {{ hospital.endereco | Endereco }}</label>
          </div>

          <Pagination :page="page"
                      :last-page="last_page"
                      @onPreviousPage="changePage(page - 1)"
                      @onNextPage="changePage(page + 1)" />
        </div>

        <p v-else
           class="noResults mt-3">
          Nenhum estabelecimento encontrado para essa busca.
        </p>

        <button class="btn btnAddLocal mb-3"
                @click="showHideForm()">
          Adicionar Novo
        </button>
      </div>

      <div v-if="showEnderecoEstabForm">
        <form v-if="showEstab">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4">
              <div class="form-group">
                <label class="label"
                       for="nomeHospital">Nome do estabelecimento</label>
                <input id="nomeHospital"
                       v-model="formData.descricao"
                       v-validate="'required'"
                       :class="{ 'is-invalid': errors.has('nomeHospital') }"
                       class="form-control form-control-sm"
                       name="nomeHospital"
                       placeholder="Hospital Central Sorocabana"
                       required
                       type="text"
                       @change="changeNomeEstabelecimento()">
                <small v-if="errors.has('nomeHospital')"
                       class="invalid-feedback">{{ errors.first('nomeHospital') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-5 col-md-3 col-lg-2">
              <div class="form-group">
                <label class="label"
                       for="telHospital">Telefone</label>
                <input id="telHospital"
                       v-model="formData.telefone"
                       v-mask="'(##)#####-####'"
                       :disabled="!formData.tipo.match('[H|h]ospital')"
                       class="form-control form-control-sm"
                       maxlength="14"
                       name="telHospital"
                       placeholder="(00)00000-0000"
                       type="text">
              </div>
            </div>

            <div class="col-12 col-sm-5 col-md-3">
              <div class="form-group">
                <label class="label"
                       for="mailHospital">E-mail</label>
                <input id="mailHospital"
                       v-model="formData.email"
                       v-validate="'email'"
                       :disabled="!formData.tipo.match('[H|h]ospital')"
                       :class="{ 'is-invalid': errors.has('mailHospital') }"
                       class="form-control form-control-sm"
                       name="mailHospital"
                       placeholder="email@email.com.br"
                       type="email">
                <small v-if="errors.has('mailHospital')"
                       class="invalid-feedback">{{ errors.first('mailHospital') }}</small>
              </div>
            </div>

            <div class="col-12 col-sm-3 align-self-end mb-1">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input id="estabAtivo"
                         v-model="formData.ativo"
                         :disabled="(formData.tipo !== 'hospital')"
                         class="custom-control-input"
                         name="estabAtivo"
                         type="checkbox">
                  <label class="custom-control-label"
                         for="estabAtivo">Ativo</label>
                </div>
              </div>
            </div>
          </div>
        </form>
        <LocalOcorrenciaSugestao v-if="listaHospitais.length > 1 && formData.tipo == 'hospital'"
                                 :prop-lista-hospitais="listaHospitais"
                                 @changeHospital="changeHospital" />

        <div class="endereco">
          <BoxEndereco v-if="formData.tipo !== 'ignorado'"
                       :data="adress"
                       :no-header="false"
                       :disabled="false"
                       @onEnderecoAdd="receiveAddress" />
        </div>
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <button class="btn btn-sm btn-light mr-2"
                  @click="voltar()">
            Voltar
          </button>

          <button v-if="Object.entries(edit).length"
                  class="btn btn-sm btn-secondary"
                  type="button"
                  :disabled="Object.entries(edit).length === 0 && formData.tipo === 'hospital' && Object.entries(estabelecimento).length === 0"
                  @click="formAddEstab">
            Editar
          </button>

          <button v-if="!Object.entries(edit).length"
                  class="btn btn-sm btn-secondary"
                  type="button"
                  @click="formAddEstab">
            Adicionar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import BoxEndereco from '../BoxEndereco.vue'
  import Pagination from '../Pagination'
  import LocalOcorrenciaSugestao from '../Obito/Passos/Sessoes/LocalOcorrenciaSugestao'

  /* constants */
  import objSwal from '@/constants/swalValues'
  import BrazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades"

  /* libraries */
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  /* services */
  import EnderecosService from "@/services/Enderecos"
  import HospitaisService from "@/services/HospitaisService"

  export default {
    name: "FormLocalOcorrencia",
    components: {
      BoxEndereco,
      Pagination,
      LocalOcorrenciaSugestao
    },
    props: {
      dados: { type: Object , default: ()=> {} },
      hideSearch: { type: Boolean , default: false },
      edit: { type: Object, default: ()=> {} },
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: {type: Object, default: () => ({})},
      propListaHospitais: {type: Array, default: () => ([])}
    },
    data () {
      return {
        locaisOcorrencia: [
          { text: 'hospital', opt: 'Hospital' },
          { text: 'domicilio', opt: 'Domicílio' },
          { text: 'outros estabelecimentos de saude', opt: 'Outros Estabelecimentos de Saúde' },
          { text: 'outros', opt: 'Outros'},
          { text: 'ignorado', opt: 'Ignorado'}
        ],
        localBusca: '',
        estabelecimento: {},
        formData: {
          tipo: 'hospital',
          ativo: true
        },
        selectsOptions: {
          states: [...BrazilianStates],
          cities: []
        },
        adress: {},
        // inicio - variáveis de controle dos campos do modal
        showEstab: false,
        showEstabForm: false,
        showHospitais: false,
        showEnderecoEstabForm: false,
        // fim - variáveis de controle dos campos do modal
        listaHospitais: [],
        results: [],
        uf: null,
        cidade: null,
        page: 1,
        last_page: 1,
        error_local_ocorrencia: false
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    watch: {
      dados () {
        if (this.dados && !this.dados.tipo) this.formData.tipo = 'hospital'
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propListaHospitais () {
        this.listaHospitais = this.propListaHospitais
      }
    },
    mounted () {
      if (Object.entries(this.edit).length) {
        this.formData = this.edit
        this.formData.tipo = this.edit.sub_tipo
        this.adress = this.edit.endereco ? { ...this.edit.endereco } : {}

        if (this.formData.sub_tipo === 'hospital' || this.formData.sub_tipo === 'outros estabelecimentos de saude') {
          this.showEstabForm = true
          this.showEstab = true
        }

        if (this.formData.sub_tipo === 'hospital' && this.formData.hospital) {
          this.formData.telefone = this.formData.hospital.telefone
          this.formData.email = this.formData.hospital.email
          this.formData.ativo = this.formData.hospital.ativo
        }

        this.showEnderecoEstabForm = true
      }

      this.verifyErrorsCarga()
    },
    methods: {
      init () {
        if (this.propCartorio && this.propCartorio.endereco) {
          if (!Object.values(this.adress).length && !this.formData.descricao) {
            this.adress = {
              uf: this.propCartorio.endereco.uf,
              cidade: this.propCartorio.endereco.cidade,
              ibge: this.propCartorio.endereco.ibge
            }
          }
        }
      },
      async searchLocal () {
        this.init()

        loader({ text: 'Buscando locais de ocorrência...', active: true })

        const payload = {
          cartorio_id: this.$store.state.auth.cartorio_id,
          uf: this.uf,
          cidade: this.cidade,
          nome: this.localBusca,
          ativo: 1,
          perPage: 5
        }

        try {
          const result = await HospitaisService.getHospitais(payload)

          // Atualiza as variáveis para listagem
          this.page = result.page
          this.showHospitais = true
          this.listaHospitais = result.data
          this.last_page = result.lastPage
          this.estabelecimento = {}
        } catch (error) {
          this.onError('Erro ao efetuar busca de estabelecimentos para local de ocorrência', error.message || '')
        }

        loader({ text: '', active: false })
      },
      changeLocal (tipo) {
        this.init()

        this.showHospitais = false

        this.showEnderecoEstabForm = tipo !== 'hospital' ? true : false

        this.showEstab = tipo === 'outros estabelecimentos de saude' ? true : false
      },
      showHideForm () {
        this.showEstab = true
        this.showEstabForm = true
        this.showEnderecoEstabForm = true
        this.formData.descricao = this.localBusca

        if (this.showEstabForm) {
          this.estabelecimento = {}
        }
      },
      voltar () {
        if (this.formData.tipo === 'hospital' && this.showEstabForm && this.listaHospitais.length > 0 && !Object.entries(this.edit).length) {
          this.showEstab = false
          this.showEstabForm = false
          this.showEnderecoEstabForm = false
          return
        }

        this.$root.$emit('bv::hide::modal', 'localOcorrencia')
      },
      async formAddEstab () {
        this.deleteError(['LOCAL DO NASCIMENTO', 'LOCAL DA OCORRÊNCIA'])

        if (!this.formData.descricao && !this.estabelecimento.nome && (this.formData.tipo == 'hospital' || this.formData.tipo == "UNIDADE_SAUDE")) {
          return this.onError('Erro!', 'Nome do hospital obrigatório.')
        }

        const objEnvio = {
          ...this.formData,
          nome: this.formData.descricao,
          endereco: this.adress,
          cartorio_id: this.$store.state.auth.cartorio_id,
          endereco_id: this.adress.endereco_id
        }

        this.estabelecimento = {
          ...this.estabelecimento,
          endereco_id: null,
          endereco: {...this.estabelecimento.endereco, endereco: null}
        }
        const valid = await this.$validator.validate()

        const {errors: {items}} = this.$validator
        let emptyNumber = false

        if (items && items.length) {
          emptyNumber = !!items.find(item => item.field == 'numero' || item.field == 'codigo_ibge')
        }

        if (!valid || emptyNumber) return

        this.$validator.validateAll().then(async (resp) => {
          if (!resp) { return }

          // Novo hospital
          if (!Object.entries(this.edit).length && objEnvio.tipo === 'hospital' && objEnvio.nome) {
            return this.cadastraHospital(objEnvio)
          }

          // Atualiza hospital
          if (Object.entries(this.edit).length && objEnvio.tipo === 'hospital') {
            const hospitalId = objEnvio.hospital_id || objEnvio.hospital.hospital_id
            this.$emit('addOcorrencia', { ...objEnvio })
            return this.onSuccess('Local de ocorrência cadastrado!', '')
            //return this.atualizaHospital(objEnvio, hospitalId)
          }

          // Hospital selecionado
          if (this.formData.tipo === 'hospital' && this.estabelecimento) {
            this.$emit('addOcorrencia', { ...this.estabelecimento })
            return this.onSuccess('Local de ocorrência cadastrado!', '')
          }

          // Outros tipos
          if (this.formData.tipo === 'domicilio' || this.formData.tipo === 'outros' || this.formData.tipo === 'outros estabelecimentos de saude' || this.formData.tipo === 'ignorado') {
            this.$emit('addOcorrencia', { ...this.formData, endereco: this.adress })
            return this.onSuccess('Local de ocorrência cadastrado!', '')
          }
        })
      },
      verifyType (tipo) {
        if (tipo === 'ignorado') {
          this.adress = {
            uf: null,
            cidade: null,
            ibge: null
          }
        }
      },
      async cadastraHospital (objEnvio) {
        try {
          loader({ text: 'Cadastrando local de ocorrência...', active: true })

          const hospital = await HospitaisService.saveHospitais(objEnvio)
          this.$emit('addOcorrencia', {
            ...objEnvio,
            endereco: {...objEnvio.endereco, endereco_id: null},
            hospital_id: hospital.hospital_id
          })
          this.onSuccess('Local de ocorrência cadastrado!', '')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro ao cadastrar hospital!', message.message)
        } finally {
          loader({ text: '', active: false })
        }
      },
      async atualizaHospital (objEnvio, hospitalId) {
        try {
          loader({ text: 'Atualizando local de ocorrência...', active: true })

          const hospital = await HospitaisService.updateHospitais(objEnvio, hospitalId)
          this.$emit('addOcorrencia', { ...objEnvio, ...hospital })
          this.onSuccess('Local de ocorrência atualizado!', '')
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro ao atualizar hospital!', message.message)
        } finally {
          loader({ text: '', active: false })
        }
      },
      cleanSelected () {
        // Padrão das variáveis
        this.localBusca = ''
        this.formData = {
          tipo: 'hospital',
          ativo: true
        }
        this.adress = {}
        this.showEstabForm = false
        this.listaHospitais = []

        this.$emit('clearData')
      },
      receiveAddress (val) {
        this.adress = val
      },
      onSuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.success)
      },
      onError (title, text) {
        objSwal.error.title = title
        objSwal.error.text = text

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        return Swal.fire(objSwal.error)
      },
      async changeNomeEstabelecimento () {
        if (this.formData.sub_tipo === 'hospital' || this.formData.tipo === 'hospital') {
          try {
            loader({ active: true })

            this.results = await HospitaisService.getHospitais({
              cartorio_id: this.$store.state.auth.cartorio_id,
              nome: this.formData.descricao,
              ativo: 1
            })

            this.listaHospitais = this.results.data
          } catch (error) {
            this.onError('Não foi possível buscar o hospital, tente novamente!', '')
          } finally {
            loader({ active: false })
          }
        }
      },
      async changePage (page) {
        const payload = {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.localBusca,
          page: page,
          ativo: 1,
          perPage: 5
        }

        try {
          this.results = await HospitaisService.getHospitais(payload)

          // Atualiza as variáveis para a listagem
          this.page = page
          this.last_page = this.results.lastPage
          this.listaHospitais  = this.results.data
        } catch (error) {
          this.onError('Erro ao efetuar busca de estabelecimentos para local de ocorrência', error.message || '')
        }
      },
      async ufChanged (uf) {
        if (!uf) {
          this.cidade = null
          return
        }

        loader({ active: true })

        const payload = {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.localBusca,
          uf: this.uf,
          ativo: 1,
          perPage: 5
        }

        try {
          this.results = await HospitaisService.getHospitais(payload)

          // Atualiza as variáveis para a listagem
          this.page = 1
          this.last_page = this.results.lastPage
          this.listaHospitais = this.results.data
          this.showHospitais = true
        } catch (error) {
          this.onError('Erro ao efetuar busca de estabelecimentos para local de ocorrência', error.message || '')
        }

        for (const state of this.selectsOptions.states) {
          if (state.uf !== uf) continue

          this.uf = state.uf
          this.cidade = null

          try {
            this.selectsOptions.cities = Cidades.filter(cidade => cidade.uf == state.uf)
            this.selectsOptions.cities.push({nome: 'Outro'})
            break
          } catch (error) {
            this.onError('Erro ao efetuar busca de estabelecimentos para local de ocorrência', error.message || '')
          }
        }

        loader({ active: false })
      },
      async cityChanged () {
        if (!this.cidade) return

        loader({ active: true })

        const payload = {
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.localBusca,
          cidade: this.cidade,
          ativo: 1,
          perPage: 5
        }

        try {
          this.results = await HospitaisService.getHospitais(payload)

          // Atualiza as variáveis para a listagem
          this.page = 1
          this.last_page = this.results.lastPage
          this.listaHospitais = this.results.data
          this.showHospitais = true
        } catch (error) {
          this.onError('Erro ao efetuar busca de estabelecimentos para local de ocorrência', error.message || '')
        }

        loader({ active: false })
      },
      verifyErrorsCarga () {
        this.error_local_ocorrencia = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if (['LOCAL DO NASCIMENTO', 'LOCAL DA OCORRÊNCIA'].indexOf(key) != -1) this.error_local_ocorrencia = true
        })
      },
      deleteError (errors) {
        this.$emit('deleteError', errors)
      },
      changeHospital (hospital) {
        if (hospital) {
          this.formData = {
            hospital,
            ...hospital,
            endereco: {...hospital.endereco, endereco_id: null},
            hospital_id: hospital.hospital_id,
            descricao: hospital.nome,
            endereco_id: null,
            tipo: 'hospital'
          }

          this.adress = {...hospital.endereco, endereco_id: null}
        } else {
          this.formData = {...this.edit}
          this.adress = {...this.edit.endereco}
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .noResults {
    font-size: pxToRem(18);
    font-weight: 500;
    text-align: center;
    margin-left: 1rem;
  }

  .titleModal {
    font-size: pxToRem(20);
    font-weight: 500;
  }
</style>
